import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from './MetaPixel';
export const CHECKOUT_URL = 'https://dance-pronta.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Scarica il Pacchetto DANCE PRONTA™ Ora',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} onClick={() => {
    if (!isInternal) {
      trackPixelEvent('InitiateCheckout', {
        value: 19,
        currency: 'EUR'
      });
    }
  }} className={`group mt-2.5 inline-flex items-center justify-center gap-3 rounded-full bg-brand px-[35px] py-6 text-center text-xs font-extrabold uppercase leading-tight text-white shadow-soft transition-[transform,background-color] duration-200 ease-out hover:-translate-y-0.5 hover:bg-brand-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:py-7 sm:text-sm ${className}`} data-id="element-43" data-mp="qir0vgdncusn">
      <span className="-mr-[0.12em] tracking-[0.1em]" data-id="element-44" data-mp="3exuao9l1kqfd">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-45" data-mp="3ewj6w9rljio9" />
    </a>;
}